import AnamneseRepository from '@/shared/http/repositories/socialProject/anamnese'
import BreadCrumb from '@/components/layout/BreadCrumb/breadCrumb.vue'
import Pagination from '@/components/layout/Pagination/pagination.vue'
import Search from '@/components/layout/Search/search.vue'
import fab from 'vue-fab'
import Roles from '@/shared/mixins/hasRoles'
import { IsSuccessCode } from '@/shared/utils/API'
import {toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'Anamnese',

  components: {
    [BreadCrumb.name]: BreadCrumb,
    [Search.name]: Search,
    [Pagination.name]: Pagination,
    fab
  },

  mixins: [Roles],

  data: () => ({
    anamneseGroups: [],
    labelSearch: 'Grupos de Anamnese',
    showDeleteModal: false,
    id: null,
    searchText: null,
    emptyAnamnese: 'Não há grupos de anamnese cadastradas.',
    fields: [
      {
        key: 'name',
        label: 'Questão',
        class: 'left-header-border text-center',
      },
      {
        key: 'action',
        label: 'AÇÕES',
        class: 'right-header-border text-center'
      }
    ],
    pagination: {
      count: 1,
      limit: 10,
      index: 1
    }
  }),

  computed: {
    breadCrumb() {
      return {
        breadcrumbItems: [
          {
            text: 'Dashboard',
            href: this.$router.resolve({ name: 'Dashboard' }).href
          },
          {
            text: 'Anamnese',
            active: true
          }
        ]
      }
    }
  },

  created() {
    this.getAll()
  },

  methods: {
    getAll() {
      loading.push()
      AnamneseRepository.GetAll(this.searchText, this.pagination)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.anamneseGroups = res.data.data
          this.pagination = {
            count: res.data.count,
            limit: res.data.pagingLimit,
            index: res.data.pagingIndex
          }
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao carregar grupos de anamnese', 'ERRO')
        })
    },

    search(searchText) {
      this.searchText = searchText
      this.getAll()
    },

    onDelete() {
      loading.push()
      AnamneseRepository.Delete(this.id)
        .then(res => {
          if (!IsSuccessCode(res)) return Promise.reject()

          this.getAll()
          this.showDeleteModal = false
          toast.success('Grupo de anamnese excluído com sucesso!', 'EXCLUSÃO DE ANAMNESE')
          loading.pop()
          return Promise.resolve()
        })
        .catch(() => {
          loading.pop()
          toast.error('Erro ao excluir grupo de anamnese', 'ERRO')
        })
    },

    selectRow(id) {
      this.showDeleteModal = true
      this.id = id
    }
  }
}
